export default "__VITE_ASSET__DIVqjqde__"